import { useRef } from "react";
import { isAndroid } from "@scrile/tools/dist/lib/browserUtils";
import useController from "./controller";
import useBreakPoints from "../../../../../../hooks/useBreakPoints";
import useKeepScrollPosition from "../../../../../../hooks/useKeepScrollPosition";

function useViewController(token: string) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { shouldScrollToBottom } = useKeepScrollPosition(containerRef);
  const { desktopUp, mobileLandscape } = useBreakPoints();

  const onFocus = () => {
    if (isAndroid()) {
      shouldScrollToBottom.current = true;
    }
  };

  const { messages } = useController(token, containerRef, shouldScrollToBottom);

  return {
    containerRef,
    messages,
    onFocus,
    desktopUp,
    mobileLandscape,
  };
}

export default useViewController;
